module.exports = __webpack_public_path__ + "assets/images/project/satellite-gifs/nusajaya-desktop.gif?v=9f8d35bb";